import { EvidenceTypeBody } from "../../../../../../service/questionarie/bodys"
import { EvidencesTypeEnum } from "../../../../../../utils/enums/evidences";
import { removeAllReference } from "../../../../../../utils/methods/removedReference";

const typeUser = {
    CREATOR_SOLVER: 'CREATOR_SOLVER',
    CREATOR: 'CREATOR',
    SOLVER: 'SOLVER',
    APPROVER: 'APPROVER',
    CREATE: 'CREATE',
    REJECT: 'REJECT',
} as const

const removeKeys = ({ object, name }: { object: EvidenceTypeBody; name: string }) => {
    if(name === EvidencesTypeEnum.OBSERVATION_COMMENT) {
        const objectCopy = removeAllReference(object)
        delete objectCopy.amounts
        delete objectCopy.min
        delete objectCopy.description
        return objectCopy
    }
    return object
}
export { typeUser, removeKeys }
